<template>
  <v-form ref="form" v-model="valid" @submit.prevent="submit">
    <v-text-field
      v-model="form.adminEmail"
      label="Correo de acceso *"
      type="email"
      :rules="emailRules"
      outlined
      dense
      class="mb-2"
    />
    <v-text-field
      v-model="form.firstName"
      label="Nombre *"
      :rules="requiredRules"
      outlined
      dense
      class="mb-2"
    />
    <v-text-field
      v-model="form.lastName"
      label="Apellido *"
      :rules="requiredRules"
      outlined
      dense
      class="mb-2"
    />
    <v-alert type="info" dense outlined class="mb-0 text-caption">
      Si el correo ya existe en la plataforma, solo se vinculará al negocio.
      Si es nuevo, se enviará una invitación con contraseña temporal.
    </v-alert>
  </v-form>
</template>

<script>
export default {
  name: 'PlatformAccountForm',
  data() {
    return {
      valid: false,
      form: {
        adminEmail: '',
        firstName: '',
        lastName: '',
      },
      requiredRules: [v => !!v || 'Requerido'],
      emailRules: [
        v => !!v || 'Requerido',
        v => /.+@.+\..+/.test(v) || 'Correo inválido',
      ],
    };
  },
  methods: {
    submit() {
      if (!this.$refs.form.validate()) return false;
      this.$emit('submit', { ...this.form });
      return true;
    },
    reset() {
      this.form = { adminEmail: '', firstName: '', lastName: '' };
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    getPayload() {
      return { ...this.form };
    },
  },
};
</script>
